import React, { FunctionComponent } from "react";

const XLogoTwitterIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/logos/social-medias/x-logo-twitter
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentcolor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.647 23.173 0.75 0.75l5.60304 0L23.25 23.173h-5.603Z"
      ></path>
      <path
        stroke="currentcolor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m22.4548 0.75 -8.9068 9.5514"
      ></path>
      <path
        stroke="currentcolor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m1.54507 23.173 8.90013 -9.5442"
      ></path>
    </svg>
  );
};

export default XLogoTwitterIcon;
